import { Injectable } from '@angular/core';
import { FormBuilder, FormGroup, Validators, AbstractControl, ValidatorFn } from '@angular/forms';
import { Validacoes } from 'app/utils/validacoes';
import { Cadastro } from '../interfaces/cadastro';
import * as cnpj from '@fnando/cnpj';
import * as cpf from '@fnando/cpf';


@Injectable({
  providedIn: 'root'
})
export class CadastroUtilsService {
  
  buildForm(fb: FormBuilder, cad: Cadastro): FormGroup {
    const form = fb.group({
      // geral
      id: [cad?.id],
      codigo: [cad?.codigo],
      uuid: [cad?.uuid],
      desativado: [cad?.desativado],
      razaoSocial: [cad?.razaoSocial, [Validators.required]],
      nomeFantasia: [cad?.nomeFantasia, [Validators.required]],
      celular: [cad?.celular, [Validators.required]],
      telefone1: [cad?.telefone1],
      cep: [cad?.cep, [Validators.required]],
      cadMun: [cad?.cadMun, [Validators.required]],
      cadCadastroGrupo: [cad?.cadCadastroGrupo, [Validators.required]],
      endereco: [cad?.endereco, [Validators.required]],
      numero: [cad?.numero, [Validators.required]],
      complemento: cad?.complemento,
      bairro: [cad?.bairro, [Validators.required]],
      pessoa: [cad?.pessoa, [Validators.required]],
      contribuinteIcms: [cad?.contribuinteIcms, [Validators.required]],
      cpfCnpj: [cad?.pessoa === 'Fisica' ? cad?.cpf : cad?.inscricaoFederal, [Validacoes.validaCpfCnpj]],
      rgInscricao: [cad?.pessoa === 'Fisica' ? cad?.rg : cad?.inscricaoEstadual, []],
      cnh: [cad?.cnh],
      inscricaoFederal: [cad?.inscricaoFederal],
      uf: [cad?.cadMun?.uf],
      cpf: [cad?.cpf],
      rg: [cad?.rg],
      inscricaoEstadual: [cad?.inscricaoEstadual],
      inscricaoCadPro: [cad?.inscricaoCadPro],
      dataNasc: [cad?.dataNasc, [Validators.required]],
      email: [cad?.email],
      obs: [cad?.obs],
      limiteCredito: [cad?.limiteCredito],
      chkAnaliseCredito: [cad?.chkAnaliseCredito ?? true],
      cliente: [cad?.cliente || false],
      fornecedor: [cad?.fornecedor || false],
      vendedor: [cad?.vendedor || false],
      produtor: [cad?.produtor || false],
      funcionario: [cad?.funcionario || false],
      trabalhador: [cad?.trabalhador || false],
      transportador: [cad?.transportador || false],
      orgao: [cad?.orgao || false],
      motorista: [cad?.motorista || false],
      sindicato: [cad?.sindicato || false],
      lojaOnline: [cad?.lojaOnline || false],
      app: [cad?.app || false],
      empresaRemota: [cad?.empresaRemota || false],
      empresaAutomacao: [cad?.empresaAutomacao || false],
      empresaServicosMecanico: [cad?.empresaServicosMecanico || false],
      empresaTransporte: [cad?.empresaTransporte || false],
      empresaConsultoria: [cad?.empresaConsultoria || false],
      empresaMDFe: [cad?.empresaMDFe || false],
      empresaPontoAtendimento: [cad?.empresaPontoAtendimento || false],
      pontoAtendimento: [cad?.pontoAtendimento || false],
      urlApi: [cad?.urlApi],
      urlFotoLoja: [cad?.urlFotoLoja],
      urlLogo: [cad?.urlLogo],
      servidorLocal: [cad?.servidorLocal],
      filialApi: [cad?.filialApi],
      filialAccessApi: [cad?.filialAccessApi],
      socioAdm:[cad?.socioAdm],
      socioAdmEndereco: [cad?.socioAdmEndereco],
      searchCidade: '',
      searchSocio: '',
      searchEndereco: ''
    });

    // Group-level validator: require at least one identifier (cpfCnpj valid OR rgInscricao OR inscricaoCadPro)
    const atLeastOneId: ValidatorFn = (control: AbstractControl) => {
      const pessoa = control.get('pessoa')?.value;
      const cpfCnpjVal = control.get('cpfCnpj')?.value;
      const rg = control.get('rgInscricao')?.value;
      const cadpro = control.get('inscricaoCadPro')?.value;

      let cpfcnpjOk = false;
      if (cpfCnpjVal) {
        const raw = ('' + cpfCnpjVal).replace(/\D/g, '');
        if (pessoa === 'Juridica') {
          cpfcnpjOk = raw.length > 0 && cnpj.isValid(raw);
        } else {
          cpfcnpjOk = raw.length > 0 && cpf.isValid(raw);
        }
      }

      const anyId = !!cpfcnpjOk || (rg && ('' + rg).trim().length > 0) || (cadpro && ('' + cadpro).trim().length > 0);
      return anyId ? null : { atLeastOneId: true };
    };

    form.setValidators(atLeastOneId);

    return form;
  }
  


}
